import React from 'react';
import './Discount.css';
import discount from '../../images/discount/discount_single.png'

const Discount = () => {
    return (
        <div className="discount-container">
            <div className="discount-title">
                <h6>TRAVEL ADVENTURES</h6>
                <h1>25% OFF</h1>
                <h5>SPEND A BEST HOLIDAYS WITH US</h5>
            </div>
            <div className="discount-img">
                <img style={{width:'400px'}} src={discount} alt="" />
            </div>
        </div>
    );
};

export default Discount;